import { css } from "theme/default/css";

export const resetScrollbar = css`
  scrollbar-width: none;

  &::-webkit-scrollbar {
    width: 0;
  }
`;
